module.exports = __webpack_public_path__ + "50aa5f41aaad26fdba7ba4815db68f01.MP3";